import { useQuery } from '@tanstack/react-query';
import type AgentApiAiJobSearchPersonasItem from '@/types/serializers/AgentApiAiJobSearchPersonasItem';

/**
 * 候補者の最新ペルソナを取得するクエリ（決定3: ダイアログ再オープン時の復元用）
 *
 * 該当ペルソナが存在しない場合、APIは `null` を返すため戻り値も null になりうる。
 */
export default function useFetchLatestAiJobSearchPersona(candidateProfileId: number | null) {
  return useQuery({
    queryKey: ['aiJobSearchLatestPersona', candidateProfileId],
    enabled: candidateProfileId !== null,
    refetchOnWindowFocus: false,
    queryFn: async (): Promise<AgentApiAiJobSearchPersonasItem | null> => {
      const response = await fetch(
        `/agent/api/ai_job_search_personas?candidate_profile_id=${candidateProfileId}`,
        {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        }
      );

      if (!response.ok) {
        throw new Error('最新ペルソナの取得に失敗しました');
      }

      const data: AgentApiAiJobSearchPersonasItem | null = await response.json();
      return data;
    },
  });
}
